import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const ApprovalPostItemSkeleton: FC = () => {
  return (
    <div
      className="tw-flex tw-min-h-[400px] tw-flex-col tw-gap-3 md:tw-flex-row"
      data-name="approval-post-skeleton"
    >
      <div className="tw-flex tw-h-[386px] tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border tw-border-grayscale-20 tw-bg-white tw-shadow-sm md:tw-max-w-[460px]">
        <div className="tw-flex tw-items-center tw-gap-3 tw-border-b tw-border-grayscale-10 tw-p-4">
          <div className="tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-bg-grayscale-10">
            <Skeleton width={24} height={24} className="tw-rounded-full" />
          </div>

          <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-1">
            <div className="tw-flex tw-items-center tw-gap-2">
              <Skeleton width={120} height={16} className="tw-rounded" />
              <Skeleton width={14} height={14} className="tw-rounded" />
            </div>
          </div>
        </div>

        <div className="tw-flex-1 tw-px-4 tw-pt-4">
          <Skeleton height={250} className="tw-rounded-md" />
        </div>
      </div>

      <div className="tw-flex tw-min-h-[400px] tw-w-full tw-flex-col tw-rounded-lg tw-border tw-border-grayscale-20 tw-bg-white tw-shadow-sm md:tw-max-w-[544px]">
        <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-grayscale-10 tw-px-4 tw-py-3">
          <div className="tw-flex tw-items-center tw-gap-2">
            <Skeleton width={20} height={20} className="tw-rounded-full" />
            <Skeleton width={100} height={16} className="tw-rounded" />
          </div>
          <Skeleton width={16} height={16} className="tw-rounded" />
        </div>

        <div className="tw-flex-1 tw-space-y-4 tw-px-4 tw-py-3">
          <div className="tw-flex tw-justify-end">
            <div className="tw-flex tw-max-w-[80%] tw-flex-col tw-items-end tw-gap-1">
              <Skeleton width={120} height={12} className="tw-rounded" />
              <div className="tw-bg-blue-500 tw-max-w-full tw-rounded-lg tw-px-3 tw-py-2">
                <Skeleton width={60} height={14} className="tw-rounded" />
              </div>
              <div className="tw-bg-blue-500 tw-max-w-full tw-rounded-lg tw-px-3 tw-py-2">
                <div className="tw-flex tw-items-center tw-gap-2">
                  <Skeleton width={16} height={16} className="tw-rounded" />
                  <Skeleton width={80} height={14} className="tw-rounded" />
                </div>
              </div>
              <div className="tw-flex tw-items-center tw-gap-1">
                <Skeleton
                  width={16}
                  height={16}
                  className="tw-bg-blue-500/20 tw-rounded"
                />
                <Skeleton
                  width={100}
                  height={12}
                  className="tw-bg-blue-500/20 tw-rounded"
                />
              </div>
            </div>
          </div>

          <div className="tw-flex tw-justify-start">
            <div className="tw-flex tw-max-w-[90%] tw-flex-col tw-gap-1">
              <div className="tw-bg-blue-800 tw-rounded-lg tw-px-3 tw-py-2">
                <div className="tw-mb-2 tw-flex tw-flex-wrap tw-gap-1">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <Skeleton
                      key={i}
                      width={80}
                      height={16}
                      className="tw-bg-blue-600/40 tw-rounded"
                    />
                  ))}
                </div>
                <Skeleton
                  width={200}
                  height={14}
                  className="tw-bg-blue-600/40 tw-rounded"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="tw-space-y-3 tw-px-4 tw-pb-4">
          <div className="tw-flex tw-items-center tw-gap-2">
            <Skeleton width={32} height={32} className="tw-rounded-full" />
            <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2  tw-rounded-md tw-px-3 tw-py-2">
              <Skeleton width={380} height={36} className="tw-rounded" />
            </div>
            <Skeleton width={36} height={36} className="tw-rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPostItemSkeleton;
